const CJ_DROPSHIPPING_ROUTE = "/dropshipping/*";

const CJ_DROPSHIPPING_PAGES = Object.freeze([
  "DropshippingPlatforms",
  "DropshippingPlatformDetails",
  "DropshippingCJConnect",
  "DropshippingCJSignup",
  "DropshippingSuppliers",
  "DropshippingSupplierProducts",
  "DropshippingAllProducts",
  "DropshippingProductDetails",
  "DropshippingImportedProducts",
  "DropshippingOrders",
  "DropshippingApiErrors",
  "DropshippingSync",
  "DropshippingAdmin",
]);

module.exports = { CJ_DROPSHIPPING_ROUTE, CJ_DROPSHIPPING_PAGES };
